import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { select, Store } from '@ngrx/store';
import { AuthService, isLoggedIn } from '..';
import { AppState } from '../../reducers';
import { map, take } from 'rxjs/operators';
import { jwtDecode } from 'jwt-decode';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RouteRedirectGuard implements CanActivate {
    constructor(
        private readonly _store: Store<AppState>,
        private readonly _auth: AuthService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this._store.pipe(
            select(isLoggedIn),
            take(1),
            map(loggedIn => {
                if (route.queryParams['SoAkIaFDah']) {
                    // Activate the route
                    return true;
                }

                const tokenExpired = this._isTokenExpired();

                // Not logged in or token expired -> SAML or login
                if (!loggedIn || tokenExpired) {
                    if (environment.runtime.enableSAMLSSO && environment.runtime.DIRECT_REDIRECT_SAML && environment.runtime.DIRECT_SAML_URL != "") {
                        // full-page SAML redirect and tell router to cancel navigation
                        this._auth.redirectToSAML();
                        return false;
                    }

                    // Activate the route
                    return true;
                }
            })
        );
    }

    private _isTokenExpired(): boolean {
        const userToken = localStorage.getItem(environment.runtime.authTokenKey);
        if (!userToken) {
            return true;
        }
        try {
            const tokenPayload = jwtDecode(userToken).exp * 1000;;
            const currentTime = Date.now();
            return !tokenPayload || tokenPayload <= currentTime;
        } catch (error) {
            return true;
        }
    }
}
